@if (displayMode) {
  <div class="content">
    @switch (displayMode) {
      @case ('NoOptions1') {
        <app-empty-list
          [iconName]="prerequisites1CreationIcon"
          [link]="prerequisites1CreationLink"
          [linkText]="prerequisites1CreationLinkLabel"
          [message1]="prerequisites1CreationMessage"
          [message2]="prerequisites1CreationMessage2"
          class="empty-list"
        ></app-empty-list>
      }
      @case ('NoOptions2') {
        <app-empty-list
          [iconName]="prerequisites2CreationIcon"
          [link]="prerequisites2CreationLink"
          [linkText]="prerequisites2CreationLinkLabel"
          [message1]="prerequisites2CreationMessage"
          [message2]="prerequisites2CreationMessage2"
          class="empty-list"
        ></app-empty-list>
      }
      @case ('NoOptions3') {
        <app-empty-list
          [iconName]="prerequisites3CreationIcon"
          [link]="prerequisites3CreationLink"
          [linkText]="prerequisites3CreationLinkLabel"
          [message1]="prerequisites3CreationMessage"
          [message2]="prerequisites3CreationMessage2"
          class="empty-list"
        ></app-empty-list>
      }
      @case ('NoElement') {
        <app-empty-list
          (linkClickedEvent)="elementCreationLinkClickedHandler()"
          [iconName]="elementCreationIcon"
          [link]="elementCreationLink"
          [linkText]="elementCreationLinkLabel"
          [message1]="elementCreationMessage"
          [message2]="elementCreationMessage2"
          [queryParams]="elementCreationQueryParams"
          class="empty-list"
        ></app-empty-list>
      }
      @case ('EmptyList') {
        <app-empty-list class="empty-list"></app-empty-list>
      }
      @case ('List') {
        <ng-content select="[list-result]"></ng-content>
      }
    }
  </div>
}
